<template>
    <div class="activities-add-or-update">
        <el-dialog
            :title="activities.id == 0 ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="activitiesDialog"
            @close="dialogClose"
        >
            <el-form
                ref="activitiesRef"
                :model="activities"
                :rules="activitiesRules"
                label-width="100px"
                v-loading="loading"
                @keyup.enter.native="newsSubmit()"
            >
                <el-form-item label="名称" prop="name">
                    <el-input
                        v-model="activities.name"
                        placeholder="请输入活动名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="活动时间" prop="startTime">
                    <el-date-picker
                        size="small"
                        v-model="dateTimeArr"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="dateTimeChange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="活动类型" prop="actType">
                    <el-radio-group v-model="activities.actType">
                        <el-radio label="0">本网站</el-radio>
                        <el-radio label="1">外链</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="外链地址"
                    prop="link"
                    v-if="activities.actType === '1'"
                >
                    <el-input
                        placeholder="请输入外链地址"
                        v-model="activities.link"
                    ></el-input>
                </el-form-item>
                <el-form-item label="活动图片" prop="thumb">
                    <el-upload
                        class="upload"
                        ref="upload"
                        :action="uploadUrl"
                        name="file"
                        :limit="1"
                        accept=".png,.jpg"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        list-type="picture"
                    >
                        <el-button slot="trigger" size="small" type="primary"
                            >选取文件</el-button
                        >

                        <div slot="tip" class="el-upload__tip">
                            只能上传 .png .jpg图片，且不超过10MB
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="上架模式" prop="model">
                    <el-select
                        v-model="activities.model"
                        width="100"
                        clearable
                        placeholder="请选择上架模式"
                    >
                        <el-option
                            v-for="item in modelList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- //模板 -->
                <el-form-item label="模板">
                    <el-select
                        v-model="activities.templateId"
                        width="100"
                        clearable
                        placeholder="请选模板模式"
                    >
                        <el-option
                            v-for="item in datalist"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动标签" prop="hotLabel">
                    <el-select
                        v-model="activities.hotLabel"
                        width="100"
                        clearable
                        placeholder="请选择活动标签"
                    >
                        <el-option
                            v-for="item in tagList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number
                        v-model="activities.sort"
                        controls-position="right"
                        :min="0"
                        size="small"
                    ></el-input-number>
                </el-form-item>
                <el-form-item label="活动内容" prop="context">
                    <el-button
                        type="info"
                        icon="el-icon-edit"
                        size="small"
                        @click="openRichDialog"
                        >前往编写活动内容</el-button
                    >
                </el-form-item>
                <el-form-item label="活动描述" class="describe-activities">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        v-model="activities.description"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="newsSubmit"
                        >提交</el-button
                    >
                    <el-button @click="activitiesDialog = false"
                        >取消</el-button
                    >
                </el-form-item>
            </el-form>
            <!-- 内层对话框 -->
            <el-dialog
                width="50%"
                title="活动内容"
                :visible.sync="innerVisible"
                append-to-body
            >
                <div id="demo1"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="innerVisible = false"
                        >确 定</el-button
                    >
                </span>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
export default {
    data() {
        const checkLink = (rule, value, callback) => {
            if (this.activities.actType === "1" && !value) {
                return callback(new Error("外链地址不能为空"));
               
            }
             callback()
        };
        return {
            datalist:[],
            // 控制活动赛事增加或更新弹框的显示与隐藏
            activitiesDialog: false,
            // 控制内层对话框的显示与隐藏
            innerVisible: false,
            // 添加或更新赛事相关参数
            activities: {
                id: null,
                sort: 0,
                name: "",
                thumb: "",
                actType: "",
                description: "",
                model: "",
                hotLabel: "",
                context: "",
                startTime: "",
                endTime: "",
                link: "",
                templateId:""
            },
            // templateId:'',
            // 日期时间选择器的绑定值
            dateTimeArr: [],
            uploadUrl: "",
            // 赛事标签列表
            tagList: [
                // { name: "普通", id: "1" },
                { name: "最热", id: "2" },
                // { name: "最新", id: "3" },
                { name: "预告", id: "4" },
                { name: "活动回顾", id: "5" },
            ],
            // 赛事模式列表
            modelList: [
                { name: "常规模式", id: "1" },
                { name: "倒计时模式", id: "2" },
                { name: "预告模式", id: "3" },
            ],
            // 保存富文本实例
            editor: null,
            // 保存图片地址数组
            fileList: [],
            loading: false,
            // 表单验证规则
            activitiesRules: {
                name: [
                    {
                        required: true,
                        message: "请输入活动名称",
                        trigger: "blur",
                    },
                ],
                startTime: [
                    {
                        required: true,
                        message: "请输入活动开始时间和结束时间",
                        trigger: "blur",
                    },
                ],
                actType: [
                    {
                        required: true,
                        message: "请选择活动类型",
                        trigger: "change",
                    },
                ],
                thumb: [
                    {
                        required: true,
                        message: "请上传活动图片",
                        trigger: "blur",
                    },
                ],
                model: [
                    {
                        required: true,
                        message: "请选择活动类型",
                        trigger: "change",
                    },
                ],
                context: [
                    {
                        required: true,
                        message: "请输入活动内容",
                        trigger: "change",
                    },
                ],
                hotLabel: [
                    {
                        required: true,
                        message: "请输入活动标签",
                        trigger: "change",
                    },
                ],
                link: [{ validator: checkLink, trigger: "blur" }],
            },
        };
    },
    watch: {
        "activities.actType": function (val) {
            if (val === "0") {
                this.activities.link = "";
            }else{
                this.activities.link
            }
        },
    },
    methods: {
        // 初始化？？？
        init(id) {
            this.activities.id = id || 0;
            this.activitiesDialog = true;
            this.$nextTick(() => {
                this.$refs.activitiesRef.resetFields();
                this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
            });
            this.getlist()
            if (this.activities.id != 0) {
                this.getDetailInfo(this.activities.id);
            }
        },
        getlist(){
            this.$ajaxGet("/registrationTemplate/getList/open").then(res =>{
                console.log(res.data.data);
                this.datalist = res.data.data
            })
        },
        // 点击提交按钮触发事件
        newsSubmit() {
            // debugger
            this.$refs["activitiesRef"].validate((valid) => {
                // debugger
                if (valid) {
                    console.log(valid);
                    console.log(this.activities);
                    this.$ajaxPost(
                        `/activities/${
                            this.activities.id === 0
                                ? "save/open"
                                : "update/open"
                        }`,
                        {
                            ...this.activities,
                            id:
                                this.activities.id === 0
                                    ? null
                                    : parseInt(this.activities.id),
                        }
                    ).then(({ data }) => {
                        if (data.code === 0) {
                            this.activitiesDialog = false;
                            this.$emit("activitiesUpdated");
                            this.$message.success('保存成功')
                        } else {
                            this.$message.error(data.msg)
                            // this.$message.error(
                            //     `${
                            //         this.activities.id == 0 ? "新增" : "修改"
                            //     }失败！`
                            // );
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        openRichDialog() {
            this.innerVisible = true;
            if (!this.editor) {
                this.$nextTick(() => {
                    // 创建富文本编辑器实例
                    const editor = new wangEditor("#demo1");
                    // 配置 onchange 回调函数，将数据同步到 vue 中
                    editor.config.onchange = (newHtml) => {
                        this.activities.context = newHtml;
                    };
                    editor.config.uploadImgServer = 'https://activity.suhoo.net/api/upload/image';
                    editor.config.showLinkImg = false;
                    editor.config.uploadImgShowBase64 = true
                    editor.config.uploadFileName = "file";
                    /* editor.config.customUploadImg = function (
                        resultFiles,
                        insertImgFn
                    ) {
                        let reader = new FileReader();
                            reader.readAsDataURL(resultFiles[0]);
                            reader.onload = function (e) {
                            insertImgFn(e.target.result)
                        }
                    }; */
                    editor.config.uploadImgHooks = {
						customInsert: function (insertImg, result, editor) {
							let url = (result.data.fileInfo.domain ? result.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+result.data.fileInfo.file_path;
							insertImg(url);
                        }   
                    }
                    // 创建编辑器
                    editor.create();
                    if (this.activities.context !== "") {
                        editor.txt.html(
                            showcontent(showcontent(this.activities.context))
                        );
                        // editor.txt.html(this.activities.context);
                    }
                    this.editor = editor;
                });
            }
        },
        // 获取赛事详情
        getDetailInfo(id) {
            this.loading = true;
            this.$ajaxGet("/activities/info/open/" + id).then(({ data }) => {
                Object.keys(this.activities).forEach((key) => {
                    this.activities[key] = data.data[key];
                });
                this.loading = false;
                this.dateTimeArr.push(this.activities.startTime);
                this.dateTimeArr.push(this.activities.endTime);

                // 将图片展示
                if (this.activities.thumb) {
                    const obj = {
                        url: this.activities.thumb,
                    };
                    this.fileList = [obj];
                }
                this.activities.context = showcontent(this.activities.context);
                this.activities.description = showcontent(this.activities.description);
            });
        },
        // 关闭弹框时触发事件
        dialogClose() {
            this.fileList = [];
            this.dateTimeArr = [];
            Object.keys(this.activities).forEach((key) => {
                if (key === "id") {
                    this.activities[key] = null;
                } else if (key === "sort") {
                    this.activities[key] = 0;
                } else {
                    this.activities[key] = "";
                }
            });
            if (this.editor) {
                this.editor.destroy();
                this.editor = null;
            }
        },
        dateTimeChange(val) {
            if (val) {
                this.activities.startTime = val[0];
                this.activities.endTime = val[1];
            } else {
                this.activities.startTime = "";
                this.activities.endTime = "";
            }
        },
        // ==============图片上传相关方法=========

        // 从本地保存的上传目录中删除图片路径
        handleRemove() {
            this.activities.thumb = "";
        },
        handlePreview(file) {
            window.open(file.url, "_blank").location;
        },
        beforeUpload(file) {
            const isLt100M = file.size / 1024 / 1024 < 10;
            if (!isLt100M) {
                this.$message.error("上传文件大小不能超过 10MB!");
            }
            return isLt100M;
        },
        handleSuccess(response) {
            if (response && response.code === 0) {
                console.log(response);
                console.log("文件上传成功返回结果：", response.data);
				let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
                this.activities.thumb = url;
            }
        },
    },
};
</script>

<style lang="less" scoped>
/deep/.el-input__inner{
    text-align: left !important;
    padding: 5px !important;
}
.el-row {
    display: flex;
    align-items: center;
    .el-col {
        display: flex;
        align-items: center;
    }
}
/deep/ .el-upload-list--picture {
    .el-upload-list__item {
        width: 92px;
        height: 92px;
    }
}
/deep/ .el-date-editor {
    height: 30px;
    line-height: 30px;
}
/deep/ .el-radio__label {
    color: #606266;
}
/deep/ .el-dialog__body {
    .el-form-item {
        margin-bottom: 10px;
    }
}
/deep/ .el-form-item__error {
    padding-top: 0;
}
.el-upload__tip {
    font-size: 12px;
}
.describe-activities {
    padding-top: 5px;
}
</style>